import { Injectable } from '@angular/core';
import { CustomBaseStore } from '@city/const';
import { CityActions, OccBaseStoresService } from '@city/data-access';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable()
export class BaseStoreEffects {
  loadBaseStore$: Observable<CityActions.LoadBaseStoresSuccess | CityActions.LoadBaseStoresFail> = createEffect(() =>
    this.actions$.pipe(
      ofType(CityActions.LOAD_BASE_STORE),
      switchMap(() =>
        this.occBaseStoresService.loadBaseStores().pipe(
          map((stores: CustomBaseStore[]) => new CityActions.LoadBaseStoresSuccess(stores)),
          catchError((error) => of(new CityActions.LoadBaseStoresFail(error))),
        ),
      ),
    ),
  );

  loadBaseStoreShops$: Observable<CityActions.LoadBaseStoreShopsSuccess | CityActions.LoadBaseStoreShopsFail> =
    createEffect(() =>
      this.actions$.pipe(
        ofType(CityActions.LOAD_BASE_STORE_SHOPS),
        map(({ code }: CityActions.LoadBaseStoreShops) => code),
        switchMap((code) =>
          this.occBaseStoresService.loadBaseStorePointsOfService(code).pipe(
            map((shops) => new CityActions.LoadBaseStoreShopsSuccess(code, shops)),
            catchError((error) => of(new CityActions.LoadBaseStoreShopsFail(code, error))),
          ),
        ),
      ),
    );

  constructor(
    private actions$: Actions,
    private occBaseStoresService: OccBaseStoresService,
  ) {}
}
